import { render } from "./associationEdit.vue?vue&type=template&id=67f8ccb9&scoped=true"
import script from "./associationEdit.vue?vue&type=script&lang=js"
export * from "./associationEdit.vue?vue&type=script&lang=js"

import "./associationEdit.vue?vue&type=style&index=0&id=67f8ccb9&lang=scss&scoped=true"
import "./associationEdit.vue?vue&type=style&index=1&id=67f8ccb9&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f8ccb9"]])

export default __exports__